import { Refresh } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';

import Spacer from '../Spacer';

interface SageConnectionProps {
    sageContactId?: string;
    onRefresh?: () => void;
}

const SageConnection = ({ sageContactId, onRefresh }: SageConnectionProps) => {
    return !sageContactId ? (
        <Stack
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            sx={{
                borderColor: 'lightgray',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderRadius: '8px',
            }}
        >
            <Spacer padding={0.5} />
            <Typography>Sage Connection</Typography>
            <Spacer padding={0.3} />
            <Typography
                p={0.5}
                bgcolor="lightgray"
                border="lightgray 1px solid"
                borderRadius="18px"
            >
                Not created
            </Typography>
            <IconButton sx={{ color: '#F18F34' }} onClick={onRefresh}>
                <Refresh />
            </IconButton>
        </Stack>
    ) : null;
};
export default SageConnection;
